import { Reducer } from 'redux';
import { IKeywords } from '../../../../common/sharedTypes';
import { ManagementActionTypes } from './actions';

// Type-safe initialState!
const initialState = {
  keywords: <IKeywords[]>[],
  valid: true,
  linkReport: null,
  openWorkflowItemStep: null,
};

type IManagementStoreState = Readonly<typeof initialState>;

const reducer: Reducer<IManagementStoreState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ManagementActionTypes.UPDATE_KEYWORDS: {
      let _state = { ...state };
      _state.keywords = [
        ..._state.keywords.map((k) =>
          k.id == action.value.id ? { ...k, ...action.value } : k
        ),
      ];
      return _state;
    }
    case ManagementActionTypes.SET_KEYWORDS: {
      let _state = { ...state };
      _state.keywords = action.value;
      return _state;
    }
    case ManagementActionTypes.GET_LINK_REPORT: {
      let _state = { ...state };
      _state.linkReport = action.value;
      return _state;
    }
    case ManagementActionTypes.OPEN_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
